<div class="screen screen--plan">

  <header class="screen__head">
    <p class="belturo-eyebrow"><%= _lcs( 'Dein Aufenthalt' ) %></p>
    <h1 class="screen__title"><%= isEdit ? _lcs( "Reiseplan bearbeiten" ) : _lcs( "Reiseplan erstellen" ) %></h1>
    <p class="screen__sub"><%= _lcs( 'Name und Zeitraum deiner Reise.' ) %></p>
  </header>

  <!-- The mode travels on the element rather than in a closure: the submit
       handler is delegated from the shell (see PlanState._bind), so it sees the
       form the guest actually submitted, not the one bound at render time. -->
  <form class="planform" data-mode="<%= isEdit ? 'edit' : 'create' %>" novalidate>

    <div class="field">
      <label class="field__label" for="plan-name"><%= _lcs( 'Name deines Reiseplans' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--luggage"></i></span>
        <input class="field__input" id="plan-name" name="name" type="text" maxlength="120"
               autocomplete="off" placeholder="<%= _lcs( 'z. B. Wochenende in der Sächsischen Schweiz' ) %>"
               value="<%= plan.name %>" required />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field__label" for="plan-start"><%= _lcs( 'Anreise' ) %></label>
        <div class="field__control">
          <input class="field__input" id="plan-start" name="startDate" type="date"
                 value="<%= plan.startDate %>" required />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="plan-end"><%= _lcs( 'Abreise' ) %></label>
        <div class="field__control">
          <input class="field__input" id="plan-end" name="endDate" type="date"
                 value="<%= plan.endDate %>" required />
        </div>
      </div>
    </div>

    <p class="planform__error" data-id="form-error" hidden></p>

    <p class="planform__hint">
      <i class="icon icon--info"></i>
      <%= _lcs( 'Check-in und Check-out legen wir automatisch auf deinen ersten und letzten Tag.' ) %>
    </p>

    <button class="btn btn--primary btn--lg btn--block" type="submit">
      <i class="icon icon--check"></i> <%= isEdit ? _lcs( "Änderungen speichern" ) : _lcs( "Reiseplan anlegen" ) %>
    </button>

    <% if ( canCancel ) { %>
      <button class="btn btn--secondary btn--lg btn--block" type="button" data-act="cancel"><%= _lcs( 'Abbrechen' ) %></button>
    <% } %>

    <% if ( isEdit ) { %>
      <button class="btn btn--ghost btn--block planform__delete" type="button" data-act="delete">
        <i class="icon icon--trash-2"></i> <%= _lcs( 'Reiseplan löschen' ) %>
      </button>
    <% } %>

  </form>

</div>
